import React, { useState } from 'react';
import { ROUTE_LOGIN } from '../Util/VMConstants';
import {  VM_Colors } from '../Styles/VMStyles';
import { Box, Button } from '@mui/material';
import MUITypography from '../Components/MUITypography';
import { callForgotpassword } from '../Util/ApiHelper';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { isEmpty, toTitleCase } from '../Util/UtilHelper';
import Loader from '../Components/Loader';
import StyledInputField from '../Components/Custom/StyledInputField';

function ForgotPasswordComponent({ handleClose, updateUserID }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);

  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const integrateForgotOTP = () => {
    setLoading(true);
    callForgotpassword(email)
      .then((result) => {
        setLoading(false);
        if (result.status_code === 200) {
          updateUserID(result.user_id);
          handleClose(true);
          toast.success(result.message);
        } else {
          handleClose(false);
          alert(result.message || "Something went wrong");
        }
      })
      .catch((err) => {
        setLoading(false);
        alert(err?.response?.data?.message || err?.message || "Something went wrong");
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEmpty(email)) {
      setEmailError('Email is required');
      return;
    } else if (!validateEmail(email)) {
      setEmailError('Enter a valid email address');
      return;
    }
    setEmailError('');
    integrateForgotOTP();
  };

  return (
    <Box
      sx={{
        maxWidth: 480,
        mx: 'auto',
        mt: { xs: 4, sm: 8 },
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        textAlign: 'center',
      }}
    >
      <MUITypography variant="h4" fontWeight={700}>
        Did you forget your password?
      </MUITypography>

      <MUITypography variant="body1" color="text.secondary">
        Enter your email address used for your account and we’ll send an OTP to
        reset your password.
      </MUITypography>

        <Box mb={2}>
          <StyledInputField
            heading="Email ID"
            placeholder={toTitleCase("Enter your email")}
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (emailError) setEmailError('');
            }}
            error={!!emailError}
            helperText={emailError}
          />
        </Box>

      {/* <MUITextField
        name="email"
        label="Email ID Address"
        placeholder="Your email address"
        type="email"
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
          if (emailError) setEmailError('');
        }}
        error={!!emailError}
        helperText={emailError}
        sx={{ width: '100%' }}
      /> */}

      <Button
        variant="contained"
        fullWidth
        size="large"
        onClick={handleSubmit}
        sx={{ py: 1.5 }}
      >
        Submit
      </Button>

      <Button
        onClick={() => navigate('/' + ROUTE_LOGIN,{ replace: true })}
        sx={{
          textTransform: 'none',
          color: VM_Colors.primary,
          fontSize: '16px',
          fontWeight: 500,
          backgroundColor: 'transparent',
          '&:hover': {
            textDecoration: 'underline',
            backgroundColor: 'transparent',
          },
        }}
      >
        <u>Back to Signin</u>
      </Button>

      {loading && <Loader loading={loading} />}
    </Box>
  );
}

export default ForgotPasswordComponent;
